'use strict';

function MortgageLiability() {
  this.node = null;
  this.declaredClass = null;
  this.extends = [_MortgageController];
  this.dataSanitization = new DataSanitization();

  this._applicantFormState = false;
  this._coapplicantFormState = false;
  this._applicantLiabilitiesFormState = false;
  this._coapplicantLiabilitiesFormState = false;
  this._tmpAddress = {};
  this._actionCallbackArray = [];
  this._liabilitiesCallbacks = [];
  this._currentAction = {
    applicant: '',
    coparticipant: ''
  };
  this._validationPathsInit = '';

  this.init = function () {
    this._super();
  };

  this.initAllReady = function () {
    this._super();
  };

  this.initPage = function () {
    if (this.checkMortgageApplicationEligibility()) {
      this.$node = $(this.node);

      this.$formSteps = this.$node.find('.form-steps');
      var formSections = this.$formSteps.find('section');

      this._$applicantForm = formSections.eq(0).find('form');
      this._$coapplicantForm = formSections.eq(1).find('form');
      this._$applicantLiabilitiesForm = formSections.eq(2).find('form');
      this._$coapplicantLiabilitiesForm = formSections.eq(3).find('form');

      this._$continueButton = this.$node.find('#mortgage_liability_continue');

      this._address = {
        address: this.$node.find('[name=address]').mogo(),
        suite: this.$node.find('[name=suite]').mogo(),
        city: this.$node.find('[name=city]').mogo(),
        province: this.$node.find('[name=province]').mogo(),
        postal_code: this.$node.find('[name=postal_code]').mogo()
      };

      this._toggleAddressFields(false, this.presenter.getModelProperty('mortgage_applicant_mortgage_liability.address_is_the_same_as_applicant'));

      this._pageSections = {
        applicant: this._$applicantForm,
        coparticipant: this._$coapplicantForm,
        applicantLiabilities: this._$applicantLiabilitiesForm,
        coapplicantLiabilities: this._$coapplicantLiabilitiesForm
      };

      this._pageSectionActions = {
        create: {
          applicant: 'mortgage_applicant_mortgage_liability.create_mortgage_existing_mortgage',
          coparticipant: 'mortgage_coparticipant_mortgage_liability.create_mortgage_existing_mortgage'
        },
        update: {
          applicant: 'mortgage_applicant_mortgage_liability.update_mortgage_existing_mortgage',
          coparticipant: 'mortgage_coparticipant_mortgage_liability.update_mortgage_existing_mortgage'
        },
        remove: {
          applicant: 'mortgage_applicant.update_mortgage_participant',
          coparticipant: 'mortgage_coparticipant.update_mortgage_participant'
        }
      };

      this._setMortgageLiabilityAction('applicant');
      this._setMortgageLiabilityAction('coparticipant');
      this._setupEventHandlers();
      this._updateSubmissionState();
      this._setupWizardState();
      this._setupFormSteps();
      this._updateStrataToggle();

      // send page view analytics
      this.analytics.pushEvent('virtual-page-view');
      this.pushAnalyticsMortgageChoices();

      this.presenter.scanDOM();
      this._setupDateInput();
    }
  };

  this._hasCoApplicant = function () {
    return this.presenter.models.mortgage.has_supporter == 1;
  };

  this._setupFormSteps = function () {
    this.$formSteps.mogo().create('FormSteps', {
      steps: [
      // applicant existing mortgage
      {
        isVisible: true,
        isComplete: this._applicantFormState,
        isEditable: this._applicantFormState,
        isActive: !this._applicantFormState,
        isEnabled: true
      },
      // co-applicant existing mortgage
      {
        isVisible: this._hasCoApplicant(),
        isEnabled: this._applicantFormState,
        isActive: this._hasCoApplicant() && this._applicantFormState && !this._coapplicantFormState,
        isEditable: this._coapplicantFormState,
        isComplete: this._coapplicantFormState
      },
      // applicant liabilities
      {
        isVisible: true,
        isComplete: this._applicantLiabilitiesFormState,
        isEditable: this._applicantLiabilitiesFormState,
        isActive: this._applicantFormState && !this._applicantLiabilitiesFormState && (!this._hasCoApplicant() || this._coapplicantFormState),
        isEnabled: this._applicantFormState && (!this._hasCoApplicant() || this._coapplicantFormState)
      },
      // co-applicant liabilities
      {
        isVisible: this._hasCoApplicant(),
        isEnabled: this._applicantFormState && (!this._hasCoApplicant() || this._coapplicantFormState) && this._applicantLiabilitiesFormState,
        isActive: this._hasCoApplicant() && this._applicantFormState && this._coapplicantFormState && this._applicantLiabilitiesFormState && !this._coapplicantLiabilitiesFormState,
        isEditable: this._coapplicantLiabilitiesFormState,
        isComplete: this._coapplicantLiabilitiesFormState
      }]
    });
  };

  this._createUpdateApplicantPosthook = function (resultObj) {
    var strataToggle = this.$node.find("[name='strata_toggle']").mogo();
    if (strataToggle.val() == null && resultObj._resultObj.strata_amount.error && resultObj.currentError) {
      var currentErrorPos = resultObj._resultObj[resultObj.currentError].position;
      var strataTogglePos = $(strataToggle.containerDiv).offset();
      if (currentErrorPos.Y < strataTogglePos.top) {
        strataToggle.showError();
      } else {
        resultObj.currentError = 'strata_toggle';
        strataToggle.showErrorLabel();
      }
    } else {
      this._pageSections.applicant.mogo()._updateCurrentError();
    }
  };

  this._extendPresenter = function (action) {
    var noExistingMortgageSelectedFilter = function (otherFn, val) {
      // Get current action on open form
      var $openedForm = this._getOpenedSection(2);
      if ($openedForm && $openedForm.attr('data-action').indexOf('update_mortgage_participant') > -1) {
        return undefined;
      }

      if (typeof otherFn === 'function') {
        return otherFn(val);
      }
      return otherFn;
    }.bind(this);

    var notRefinanceFilter = function (val) {
      var $openedForm = this._getOpenedSection(2);

      // According to the code, update_mortgage_partcipant is always considered remove.
      // therefore we should not include any data other than has_existing_mortgages
      if (this.presenter.models.mortgage.type != 'refinance' || $openedForm && $openedForm.attr('data-action').indexOf('update_mortgage_participant') > -1) {
        return undefined;
      }
      return val;
    }.bind(this);

    var hasExistingMortgagesFieldFn = function hasExistingMortgagesFieldFn(val) {
      if (val === false) return val;
      return undefined;
    };

    var noop = function noop() {};

    // Set validation
    var customValidations = {
      _hooks: {},
      _has_liability_child: { sanitize: noop },
      _has_liability_alimony: { sanitize: noop },
      participant_type: {
        sanitize: noExistingMortgageSelectedFilter.bind(this)
      },
      has_existing_mortgages: {
        sanitize: hasExistingMortgagesFieldFn
      },
      address: {
        sanitize: noExistingMortgageSelectedFilter.bind(this)
      },
      suite: {
        sanitize: noExistingMortgageSelectedFilter.bind(this, notRefinanceFilter)
      },
      city: {
        sanitize: noExistingMortgageSelectedFilter.bind(this)
      },
      province: {
        sanitize: noExistingMortgageSelectedFilter.bind(this)
      },
      postal_code: {
        sanitize: noExistingMortgageSelectedFilter.bind(this)
      },
      mortgage_application_type: {
        sanitize: noExistingMortgageSelectedFilter.bind(this)
      },
      sameAsApplicant: {
        sanitize: noExistingMortgageSelectedFilter.bind(this)
      },
      payment_amount: {
        sanitize: noExistingMortgageSelectedFilter.bind(this)
      },
      payment_frequency: {
        sanitize: noExistingMortgageSelectedFilter.bind(this)
      },
      strata_amount: {
        sanitize: noExistingMortgageSelectedFilter.bind(this)
      },
      has_additional_mortgages: {
        sanitize: noExistingMortgageSelectedFilter.bind(this)
      },
      is_planning_to_sell: {
        sanitize: noExistingMortgageSelectedFilter.bind(this)
      },
      maturity_date: {
        sanitize: noExistingMortgageSelectedFilter.bind(this)
      },
      address_is_the_same_as_applicant: {
        sanitize: noExistingMortgageSelectedFilter.bind(this, notRefinanceFilter)
      },
      property_usage: {
        sanitize: noExistingMortgageSelectedFilter.bind(this)
      },
      strata_toggle: {
        sanitize: noop
      }
    };

    var viewMap = {
      // No existing mortgage (applicant/coparticipant)
      'mortgage_applicant.participant_type': {
        set: noExistingMortgageSelectedFilter.bind(this)
      },
      'mortgage_applicant.address': {
        set: noExistingMortgageSelectedFilter.bind(this)
      },
      'mortgage_applicant.suite': {
        set: noExistingMortgageSelectedFilter.bind(this, notRefinanceFilter)
      },
      'mortgage_applicant.city': {
        set: noExistingMortgageSelectedFilter.bind(this)
      },
      'mortgage_applicant.province': {
        set: noExistingMortgageSelectedFilter.bind(this)
      },
      'mortgage_applicant.postal_code': {
        set: noExistingMortgageSelectedFilter.bind(this)
      },
      'mortgage_applicant.mortgage_application_type': {
        set: noExistingMortgageSelectedFilter.bind(this)
      },
      'mortgage_applicant.sameAsApplicant': {
        set: noExistingMortgageSelectedFilter.bind(this)
      },
      'mortgage_applicant.payment_amount': {
        set: noExistingMortgageSelectedFilter.bind(this)
      },
      'mortgage_applicant.payment_frequency': {
        set: noExistingMortgageSelectedFilter.bind(this)
      },
      'mortgage_applicant.strata_amount': {
        set: noExistingMortgageSelectedFilter.bind(this)
      },
      'mortgage_applicant.is_planning_to_sell': {
        set: noExistingMortgageSelectedFilter.bind(this)
      },
      'mortgage_applicant.maturity_date': {
        set: noExistingMortgageSelectedFilter.bind(this)
      },
      'mortgage_applicant.has_additional_mortgages': {
        set: noExistingMortgageSelectedFilter.bind(this)
      },
      'mortgage_applicant.strata_toggle': {
        set: function set() {}
      },
      'mortgage_applicant.address_is_the_same_as_applicant': {
        set: noExistingMortgageSelectedFilter.bind(this, notRefinanceFilter)
      },
      'mortgage_applicant.property_usage': {
        set: function set() {}
      },

      'mortgage_coparticipant.participant_type': {
        set: noExistingMortgageSelectedFilter.bind(this)
      },
      'mortgage_coparticipant.type': {
        set: noExistingMortgageSelectedFilter.bind(this)
      },
      'mortgage_coparticipant.mortgage_application_type': {
        set: noExistingMortgageSelectedFilter.bind(this)
      },
      'mortgage_coparticipant.sameAsApplicant': {
        set: noExistingMortgageSelectedFilter.bind(this)
      },
      'mortgage_coparticipant.payment_amount': {
        set: noExistingMortgageSelectedFilter.bind(this)
      },
      'mortgage_coparticipant.payment_frequency': {
        set: noExistingMortgageSelectedFilter.bind(this)
      },

      // Create/update mortgage liability (applicant)
      'mortgage_applicant_mortgage_liability.has_existing_mortgages': {
        set: hasExistingMortgagesFieldFn
      },
      'mortgage_applicant_mortgage_liability.address_is_the_same_as_applicant': {
        set: function (nrf, val) {
          this._toggleAddressFields(true, val);
          return nrf(val);
        }.bind(this, notRefinanceFilter)
      },
      'mortgage_applicant_mortgage_liability.sameAsApplicant': {
        set: function set() {}
      },
      'mortgage_applicant_mortgage_liability.strata_toggle': {
        set: function set() {}
      },
      'mortgage_applicant_mortgage_liability.postal_code': {
        get: function get(value) {
          if (!value || value.length < 1) return value;
          value = value.toUpperCase().replace(' ', '').split('');
          value.splice(3, 0, ' ');
          return value.join('');
        },


        set: function (value) {
          // According to the code, update_mortgage_partcipant is always considered remove.
          // this will be path 2 and does not except anything but has_existing_mortgage
          var $openedForm = this._getOpenedSection(2);
          if ($openedForm && $openedForm.attr('data-action').indexOf('update_mortgage_participant') > -1) {
            return undefined;
          }

          if (!value || value.length < 1) return value;
          value = value.toUpperCase().replace(' ', '').split('');
          value.splice(3, 0, ' ');
          return value.join('');
        }.bind(this)
      },
      'mortgage_applicant_mortgage_liability.suite': {
        set: function (val) {
          // According to the code, update_mortgage_partcipant is always considered remove.
          // this will be path 2 and does not except anything but has_existing_mortgage
          var $openedForm = this._getOpenedSection(2);
          if ($openedForm && $openedForm.attr('data-action').indexOf('update_mortgage_participant') > -1) {
            return undefined;
          }

          if (this.presenter.models.mortgage.type != 'refinance') return undefined;
          if (val == null) return '';
          return val;
        }.bind(this)
      },

      // Create/update mortgage liability (coparticipant)
      'mortgage_coparticipant_mortgage_liability.has_existing_mortgages': {
        set: hasExistingMortgagesFieldFn
      },

      // Child Support and Alimony liabilities
      'mortgage_applicant_liabilities._has_liability_child': { set: noop },
      'mortgage_applicant_liabilities._has_liability_alimony': { set: noop },
      'mortgage_applicant_liabilities.liabilities[0].id': { set: noop },
      'mortgage_applicant_liabilities.liabilities[0].monthly_amount': { set: noop },
      'mortgage_applicant_liabilities.liabilities[1].id': { set: noop },
      'mortgage_applicant_liabilities.liabilities[1].monthly_amount': { set: noop },
      'mortgage_applicant_liabilities.liabilities[2].id': { set: noop },
      'mortgage_applicant_liabilities.liabilities[2].monthly_amount': { set: noop },
      'mortgage_applicant_liabilities.liabilities[3].id': { set: noop },
      'mortgage_applicant_liabilities.liabilities[3].monthly_amount': { set: noop },
      'mortgage_applicant_liabilities.liabilities[4].id': { set: noop },
      'mortgage_applicant_liabilities.liabilities[4].monthly_amount': { set: noop },
      'mortgage_applicant_liabilities.liabilities[5].id': { set: noop },
      'mortgage_applicant_liabilities.liabilities[5].monthly_amount': { set: noop },
      'mortgage_applicant_liabilities.liabilities[6].id': { set: noop },
      'mortgage_applicant_liabilities.liabilities[6].monthly_amount': { set: noop },
      'mortgage_applicant_liabilities.liabilities[7].id': { set: noop },
      'mortgage_applicant_liabilities.liabilities[7].monthly_amount': { set: noop },
      'mortgage_applicant_liabilities.liabilities[8].id': { set: noop },
      'mortgage_applicant_liabilities.liabilities[8].monthly_amount': { set: noop },
      'mortgage_applicant_liabilities.liabilities[9].id': { set: noop },
      'mortgage_applicant_liabilities.liabilities[9].monthly_amount': { set: noop },
      'mortgage_applicant_liabilities.liabilities[10].id': { set: noop },
      'mortgage_applicant_liabilities.liabilities[10].monthly_amount': { set: noop },
      'mortgage_applicant_liabilities.liabilities[11].id': { set: noop },
      'mortgage_applicant_liabilities.liabilities[11].monthly_amount': { set: noop },
      'mortgage_coparticipant_liabilities._has_liability_child': { set: noop },
      'mortgage_coparticipant_liabilities._has_liability_alimony': { set: noop },
      'mortgage_coparticipant_liabilities.liabilities[0].id': { set: noop },
      'mortgage_coparticipant_liabilities.liabilities[0].monthly_amount': { set: noop },
      'mortgage_coparticipant_liabilities.liabilities[1].id': { set: noop },
      'mortgage_coparticipant_liabilities.liabilities[1].monthly_amount': { set: noop },
      'mortgage_coparticipant_liabilities.liabilities[2].id': { set: noop },
      'mortgage_coparticipant_liabilities.liabilities[2].monthly_amount': { set: noop },
      'mortgage_coparticipant_liabilities.liabilities[3].id': { set: noop },
      'mortgage_coparticipant_liabilities.liabilities[3].monthly_amount': { set: noop },
      'mortgage_coparticipant_liabilities.liabilities[4].id': { set: noop },
      'mortgage_coparticipant_liabilities.liabilities[4].monthly_amount': { set: noop },
      'mortgage_coparticipant_liabilities.liabilities[5].id': { set: noop },
      'mortgage_coparticipant_liabilities.liabilities[5].monthly_amount': { set: noop },
      'mortgage_coparticipant_liabilities.liabilities[6].id': { set: noop },
      'mortgage_coparticipant_liabilities.liabilities[6].monthly_amount': { set: noop },
      'mortgage_coparticipant_liabilities.liabilities[7].id': { set: noop },
      'mortgage_coparticipant_liabilities.liabilities[7].monthly_amount': { set: noop },
      'mortgage_coparticipant_liabilities.liabilities[8].id': { set: noop },
      'mortgage_coparticipant_liabilities.liabilities[8].monthly_amount': { set: noop },
      'mortgage_coparticipant_liabilities.liabilities[9].id': { set: noop },
      'mortgage_coparticipant_liabilities.liabilities[9].monthly_amount': { set: noop },
      'mortgage_coparticipant_liabilities.liabilities[10].id': { set: noop },
      'mortgage_coparticipant_liabilities.liabilities[10].monthly_amount': { set: noop },
      'mortgage_coparticipant_liabilities.liabilities[11].id': { set: noop },
      'mortgage_coparticipant_liabilities.liabilities[11].monthly_amount': { set: noop }
    };

    if (action == 'mortgage_applicant_mortgage_liability.create_mortgage_existing_mortgage' || action == 'mortgage_applicant_mortgage_liability.update_mortgage_existing_mortgage') {
      customValidations._hooks.posthook = this._createUpdateApplicantPosthook.bind(this);
    }

    customValidations._hooks.prehook = this._setupValidationPaths.bind(this, action);
    this.presenter.extendCustomValidations(action, customValidations);
    this.presenter.extendViewMap(viewMap);
  };

  this._setMortgageLiabilityAction = function (type, evt) {
    // Get value
    var val = null;
    if (evt != null) {
      val = $(evt.currentTarget).mogo().val();
    } else {
      val = this.presenter.models['mortgage_' + type].has_existing_mortgages;
    }

    // Setup actions and schemas
    if (type == 'applicant' || type == 'coparticipant') {
      var action = '';
      if (!val) {
        action = this._pageSectionActions.remove[type];
      } else if (this.presenter.hasAction(this._pageSectionActions.create[type])) {
        action = this._pageSectionActions.create[type];
      } else if (this.presenter.hasAction(this._pageSectionActions.update[type])) {
        action = this._pageSectionActions.update[type];
      }

      var obj = this._getActionTypeFromAction(action);
      if (action != this._currentAction[type]) {
        if (!this._pageSections[type].mogo().declaredClass) {
          // New form
          mogo.ready(function (action) {
            var obj = this._getActionTypeFromAction(action);
            this._extendPresenter(action);
            this.presenter.addActionToNode(this._pageSections[obj.type][0], this._pageSectionActions[obj.action][obj.type]);
            this.presenter._createValidation(this._pageSections[obj.type][0]);
          }.bind(this, action));
        } else {
          this._extendPresenter(this._pageSectionActions[obj.action][obj.type]);
          this.presenter.switchActionOnNode(this._pageSections[obj.type][0], this._pageSectionActions[obj.action][obj.type]);
        }
        this._currentAction[obj.type] = obj.action;
      }
    }
  };

  this._setupValidationPaths = function (action) {
    if (this._validationPathsInit == action) return;
    this._validationPathsInit = action;
    var obj = this._getActionTypeFromAction(action);
    this._pageSections[obj.type].mogo().removeAllValidationPaths();
    var path = '';
    if (action == this._pageSectionActions.create[obj.type] || action == this._pageSectionActions.update[obj.type]) {
      if (obj.type == 'coparticipant') {
        path = '#/oneOf/2';
      } else if (this.presenter.models.mortgage.type == 'refinance') {
        path = '#/oneOf/1';
      } else {
        path = '#/oneOf/0';
      }
    } else {
      path = '#/oneOf/2';
    }
    this._pageSections[obj.type].mogo().addValidationIncludePath(path);
  };

  this._setupEventHandlers = function () {
    this.$node.find("[name='strata_toggle']").on('change', this._onChangeStrataToggle.bind(this));
    this.$node.find('.mortgage-liability__applicant-existing').on('change', this._setMortgageLiabilityAction.bind(this, 'applicant'));
    this.$node.find('.mortgage-liability__coparticipant-existing').on('change', this._setMortgageLiabilityAction.bind(this, 'coparticipant'));
    this.$node.find('input, select').on('change', this._updateContinueButton.bind(this));

    // liabilities
    // this must bind before SchemaValidation so that we can override the SchemaValidation behavior
    this._$applicantLiabilitiesForm.on('submit', this._overrideLiabilitiesSubmit.bind(this, 'mortgage_applicant', this._$applicantLiabilitiesForm));
    this._$coapplicantLiabilitiesForm.on('submit', this._overrideLiabilitiesSubmit.bind(this, 'mortgage_coparticipant', this._$coapplicantLiabilitiesForm));

    this._$applicantLiabilitiesForm.find('[data-mogo-ui=BooleanGroup] input').on('change', this._onFieldChange);
    this._$coapplicantLiabilitiesForm.find('[data-mogo-ui=BooleanGroup] input').on('change', this._onFieldChange);

    this._setupLiabilities('mortgage_applicant', this._$applicantLiabilitiesForm);
    this._setupLiabilities('mortgage_coparticipant', this._$coapplicantLiabilitiesForm);

    this.presenter.addComputedVariable('applicantLiabilitiesIndex', ['mortgage.has_supporter'], function (has_supporter) {
      return has_supporter ? 3 : 2;
    });
    this.presenter.addComputedVariable('applicantLiablitiesTotal', ['mortgage_applicant.has_liabilities', 'mortgage_applicant_liabilities.total_child_support_amount', 'mortgage_applicant_liabilities.total_alimony_amount'], function (has, a, b) {
      if (!has) return 'no';
      return Formatters.formatMoney(a + b, { optionalDecimals: true }) + ' of';
    });
    this.presenter.addComputedVariable('coparticipantLiablitiesTotal', ['mortgage_coparticipant.has_liabilities', 'mortgage_coparticipant_liabilities.total_child_support_amount', 'mortgage_coparticipant_liabilities.total_alimony_amount'], function (has, a, b) {
      if (!has) return 'no';
      return Formatters.formatMoney(a + b, { optionalDecimals: true }) + ' of';
    });
  };

  this._updateChildAndAlimonyTempVariable = function (model) {
    var hasChildSupport = false;
    var hasAlimony = false;

    if (this.presenter.getModelProperty(model + '.has_liabilities') !== false) {
      var liabilities = this.presenter.getModelProperty(model + '_liabilities.liabilities');
      if (liabilities && liabilities.length) {
        hasChildSupport = liabilities.filter(function (v) {
          return v.type === 'child_support';
        }).length !== 0;
        hasAlimony = liabilities.filter(function (v) {
          return v.type === 'alimony';
        }).length !== 0;
      } else {
        hasChildSupport = null;
        hasAlimony = null;
      }
    }
    this.presenter.setModelProperty(model + '._has_liability_child', hasChildSupport);
    this.presenter.setModelProperty(model + '._has_liability_alimony', hasAlimony);
    this.presenter.models[model]._persistent = true;
  };

  this._setupLiabilities = function (model, $form) {
    this._updateChildAndAlimonyTempVariable(model);

    var childSupportComponent = $form.find('[data-mogo-ui=Collection][data-mogo-ui-type=child_support]').mogo();
    var alimonyComponent = $form.find('[data-mogo-ui=Collection][data-mogo-ui-type=alimony]').mogo();

    this._setupLiabilitiesYesNo(model + '._has_liability_child', childSupportComponent, $form);
    this._setupLiabilitiesYesNo(model + '._has_liability_alimony', alimonyComponent, $form);

    this.presenter.addComputedVariable(model + '_temp', [model + '_liabilities.liabilities'], this._updateContinueButton.bind(this));

    var actionName = model + '_liabilities.create_update_delete_mortgage_liabilities';
    if (this.presenter.hasAction(actionName)) this._liabilitiesCallbacks.push([actionName, this.presenter.addCallbackToAction(actionName, this._onChildSupportAlimonyResponse.bind(this, $form, model + '_liabilities', model))]);
  };

  this._setupLiabilitiesYesNo = function (model, component, $form) {
    var $boolGroup = $form.find('[data-bind=\'' + model + '\']');
    $boolGroup.find('input[value=false]').on('change', this._onClear.bind(this, model, component));

    this.presenter.addComputedVariable(model + '_temp', [model], this._onLiabilitiesChange.bind(this, component));

    // add callback
    component.onAdd.push(this._updateForm.bind(this, $form));
    component.onRemove.push(this._onRemove.bind(this, $form));
    component.onRemoveLast.push(this._onRemoveLast.bind(this, model, component, $form));
  };

  this._onRemove = function (form, item) {
    if (item) item.find('[name$=monthly_amount]').mogo().val('1');
    this._updateForm(form);
  };

  this._updateForm = function (form) {
    if (form.mogo()._initializeResultObj) {
      form.mogo()._initializeResultObj();
    }
  };

  this._onLiabilitiesChange = function (component, boolean) {
    if (boolean) component.addItem();
  };

  this._onClear = function (model, component, event) {
    event.stopImmediatePropagation(); // prevent field change validation
    this.presenter.setModelProperty(model, false); // set the model property
    component.clear(); // clear
  };

  this._onRemoveLast = function (model, component, $form) {
    var _this = this;

    if (this.presenter.getModelProperty(model)) {
      // once the change has cascaded to the form (it's data-bound to the APIModel) then update the dependant model
      $form.one('change', '[data-mogo-ui=Collection]', function () {
        _this.presenter.setModelProperty(model, false);
      });
    }
  };

  this._onChildSupportAlimonyResponse = function ($form, modelName, secondaryModelName, data, response) {
    if (response === 200) {
      this.presenter.updateModel(modelName, data);
      // push the analytics
      this.analytics.forcePushEvent('form-submit', { FormID: [$form.attr('data-analytics-id')] });
      this._updateForm($form);
      if (!secondaryModelName) {
        this._updatePageState();
      } else {
        this.presenter.updateModel(secondaryModelName, null, this._updatePageState.bind(this));
      }
    } else {
      $('#Notification').mogo().get(); // error
    }
  };

  this._onFieldChange = function () {
    $(this).parents('[data-mogo-ui=BooleanGroup]').mogo().hideError();
  };

  this._overrideLiabilitiesSubmit = function (model, $form, event) {
    var alimony = this.presenter.getModelProperty(model + '._has_liability_alimony');
    var child = this.presenter.getModelProperty(model + '._has_liability_child');

    var isAlimonyDefined = typeof alimony !== 'undefined' && alimony !== null;
    var isChildSupportDefined = typeof child !== 'undefined' && child !== null;
    var errors = [];

    if (!isAlimonyDefined) {
      this.$node.find('[data-bind=\'' + model + '._has_liability_alimony\']').mogo().showErrorLabel();
      errors.push('_has_liability_alimony');
    }
    if (!isChildSupportDefined) {
      this.$node.find('[data-bind=\'' + model + '._has_liability_child\']').mogo().showErrorLabel();
      errors.push('_has_liability_child');
    }

    if (errors.length) {
      // Push the errors for analytics
      this.analytics.forcePushEvent('form-errors', { FormErrors: [errors.join(',')] });
      // prevent the regular validation until both fields are filled out
      event.stopImmediatePropagation();
    }

    // validate the two checkbox
    if (alimony === false && child === false) {
      // update the user to has no liabilities
      event.stopImmediatePropagation();

      // set the button disabled
      this._setButtonsEnabled(this._getOpenedSection(), false);
      this.presenter.performAction(model + '.update_mortgage_participant', { has_liabilities: false }, this._onChildSupportAlimonyResponse.bind(this, $form, model, model + '_liabilities'));
    }
    return false;
  };

  this._updateContinueButton = function (e) {
    if ((!this.presenter.models.hasOwnProperty('mortgage_applicant_liabilities') || this.presenter.models.mortgage_applicant_liabilities.isPersistent()) && (!this.presenter.models.hasOwnProperty('mortgage_coparticipant_liabilities') || this.presenter.models.mortgage_coparticipant_liabilities.isPersistent()) && (!this.presenter.models.hasOwnProperty('mortgage_applicant_mortgage_liability') || this.presenter.models.mortgage_applicant_mortgage_liability.isPersistent()) && (!this.presenter.models.hasOwnProperty('mortgage_coparticipant_mortgage_liability') || this.presenter.models.mortgage_coparticipant_mortgage_liability.isPersistent()) && (!this.presenter.models.hasOwnProperty('mortgage_applicant') || this.presenter.models.mortgage_applicant.isPersistent()) && (!this.presenter.models.hasOwnProperty('mortgage_coparticipant') || this.presenter.models.mortgage_coparticipant.isPersistent())) {
      this._$continueButton.mogo().removeDisabledState();
    } else {
      this._$continueButton.mogo().setDisabledState();
    }
  };

  this._setupDateInput = function () {
    this._$maturityDateCalendar = $('.js--maturity-date-calendar');

    this._$maturityDateCalendar.mogo().setYearValidation(function (year) {
      var today = moment();
      return today.year() <= year;
    });

    this._$maturityDateCalendar.mogo().setMonthValidation(function (year, month) {
      var today = moment();
      return today.year() < year || today.year() === year && today.month() <= month;
    });

    this._$maturityDateCalendar.mogo().setDateValidation(function (year, month, date) {
      var today = moment();
      var isBeforeThisYear = today.year() < year;
      var isBeforeThisMonth = today.year() === year && today.month() < month;
      var isBeforeThisDate = today.year() === year && today.month() === month && today.date() < date;
      return isBeforeThisYear || isBeforeThisMonth || isBeforeThisDate;
    });
  };

  // add callbacks to actions to update wizard state on submit
  this._setupWizardState = function () {
    var _this2 = this;

    this._setupActions();

    this._$continueButton.on('click.continue', function () {
      _this2._tray().moveNext();
    });

    // reset the model on any cancel or clicking edit
    this.$node.find('.js-cancel-button').on('click.reset', this._resetModels.bind(this, true));
    this.$node.find('.form-steps__heading svg').on('click.reset', this._resetModels.bind(this, false));

    // set state based on same as applicant checkbox
    this.presenter.addComputedVariable('applicant_has_submitted_data', null, function () {
      return _this2._applicantFormState;
    });

    this.presenter.addComputedVariable('coapplicant_has_submitted_data', null, function () {
      return _this2._coapplicantFormState;
    });

    this.presenter.addComputedVariable('applicant_liabilities_has_submitted_data', null, function () {
      return _this2._applicantLiabilitiesFormState;
    });
    this.presenter.addComputedVariable('coapplicant_liabilities_has_submitted_data', null, function () {
      return _this2._coapplicantLiabilitiesFormState;
    });
  };

  this._resetModels = function (closeOpen) {
    var openedSection = this.$formSteps.mogo().getAllActiveSteps();

    if (openedSection.length) {
      switch (openedSection[0].index) {
        case 0:
          this.presenter.resetModels('mortgage_applicant');
          this.presenter.resetModels('mortgage_applicant_mortgage_liability');
          this._updateStrataToggle();
          break;
        case 1:
          this.presenter.resetModels('mortgage_coparticipant');
          this.presenter.resetModels('mortgage_coparticipant_mortgage_liability');
          break;
        case 2:
          this.presenter.resetModels('mortgage_applicant');
          this.presenter.resetModels('mortgage_applicant_liabilities');
          this._updateChildAndAlimonyTempVariable('mortgage_applicant');
          this._updateForm(this._$applicantLiabilitiesForm);
          break;
        case 3:
          this.presenter.resetModels('mortgage_coparticipant');
          this.presenter.resetModels('mortgage_coparticipant_liabilities');
          this._updateChildAndAlimonyTempVariable('mortgage_coparticipant');
          this._updateForm(this._$coapplicantLiabilitiesForm);
          break;
      }

      this._updateWizardState();
      this._updateContinueButton();
    }
  };

  this._setupActions = function () {
    for (var i = 0; i < this._actionCallbackArray.length; i++) {
      this.presenter.removeCallbackFromAction(this._actionCallbackArray[i][0], this._actionCallbackArray[i][1]);
    }

    var addAction = function (action) {
      if (this.presenter.hasAction(action)) {
        this._actionCallbackArray.push([action, this.presenter.addCallbackToAction(action, this._onLiabilitySubmitResponse.bind(this, action))]);
      }
    }.bind(this);

    addAction(this._pageSectionActions.create.applicant);
    addAction(this._pageSectionActions.create.coparticipant);
    addAction(this._pageSectionActions.update.applicant);
    addAction(this._pageSectionActions.update.coparticipant);
    addAction(this._pageSectionActions.remove.applicant);
    addAction(this._pageSectionActions.remove.coparticipant);
  };

  this._updateSubmissionState = function () {
    // check if forms have set values yet
    // these values should only be updated on page load and model data save.
    this._applicantFormState = typeof this.presenter.getModelProperty('mortgage_applicant.has_existing_mortgages') === 'boolean';
    this._coapplicantFormState = typeof this.presenter.getModelProperty('mortgage_coparticipant.has_existing_mortgages') === 'boolean';
    this._applicantLiabilitiesFormState = typeof this.presenter.getModelProperty('mortgage_applicant.has_liabilities') === 'boolean';
    this._coapplicantLiabilitiesFormState = typeof this.presenter.getModelProperty('mortgage_coparticipant.has_liabilities') === 'boolean';
  };

  this._updateWizardState = function () {
    var formStep = this.$formSteps.mogo();
    var activeStep = -1;

    if (!this._applicantFormState) {
      activeStep = 0;
    } else if (this._hasCoApplicant() && this._applicantFormState && !this._coapplicantFormState) {
      activeStep = 1;
    } else if (this._applicantFormState && !this._applicantLiabilitiesFormState) {
      activeStep = 2;
    } else if (this._hasCoApplicant() && this._coapplicantFormState && !this._coapplicantLiabilitiesFormState) {
      activeStep = 3;
    }

    this._updateStep(formStep, 0, this._applicantFormState, this._applicantFormState, true, activeStep);
    this._updateStep(formStep, 1, this._coapplicantFormState, this._coapplicantFormState, this._applicantFormState, activeStep);
    this._updateStep(formStep, 2, this._applicantLiabilitiesFormState, this._applicantLiabilitiesFormState, this._applicantFormState && (!this._hasCoApplicant() || this._coapplicantFormState), activeStep);
    this._updateStep(formStep, 3, this._coapplicantLiabilitiesFormState, this._coapplicantLiabilitiesFormState, this._applicantLiabilitiesFormState, activeStep);
  };

  this._updateStep = function (formSteps, index, isComplete, isEditable, isEnabled, activeStep) {
    if (isComplete && !formSteps.isStepComplete(index)) formSteps.setStepComplete(index);
    formSteps.setStepEditable(index, isEditable);
    formSteps.setStepEnabled(index, isEnabled);
    formSteps.setStepActive(index, activeStep === index);
  };

  this._updateStrataToggle = function () {
    var val = this.presenter.getModelProperty('mortgage_applicant_mortgage_liability.strata_amount');
    if (val != null && val > 0) {
      // There is strata amount
      this.$node.find("[name='strata_toggle']").mogo().val(true);
      this.$node.find("[name='strata_amount']").mogo().setReadOnly(false);
      this.$node.find('.strata-group').show();
    } else if (val != null && val <= 0) {
      this.$node.find("[name='strata_toggle']").mogo().val(false);
      this.$node.find("[name='strata_amount']").mogo().setReadOnly(true);
      this.$node.find('.strata-group').hide();
    } else {
      this.$node.find("[name='strata_toggle']").mogo().val('');
      this.$node.find("[name='strata_amount']").mogo().setReadOnly(false);
      this.$node.find('.strata-group').hide();
    }
  };

  this._updateStrataAmount = function (bool) {
    if (bool === true) {
      this.$node.find("[name='strata_amount']").mogo().setReadOnly(false);
      this.$node.find('.strata-group').show();
      this.presenter.setModelProperty('mortgage_applicant_mortgage_liability.strata_amount', undefined);
      this.$node.find("[name='strata_amount']").mogo().val('');
    } else if (bool === false) {
      this.$node.find("[name='strata_amount']").mogo().setReadOnly(true);
      this.$node.find('.strata-group').hide();
      this.presenter.setModelProperty('mortgage_applicant_mortgage_liability.strata_amount', 0);
      this.$node.find("[name='strata_amount']").mogo().val('0');
    }
  };

  this._onChangeStrataToggle = function (evt) {
    var val = $(evt.currentTarget).mogo().val();
    this._updateStrataAmount(val);
  };

  this._onLiabilitySubmitResponse = function (action, data, response) {
    if (response === 200) {
      // Set buttons to load state
      var sectionOpened = this._getOpenedSection(2);

      if (sectionOpened !== null) {
        // check if this was resulting from these sections updates
        this._setButtonsEnabled(sectionOpened, false);

        var isCoApp = action.indexOf('coparticipant') > -1;
        this.analytics.forcePushEvent('form-submit', {
          FormID: [isCoApp ? 'MogoMortgage-Form submission-CoLiability-null-Form' : 'MogoMortgage-Form submission-Liability-null-Form']
        });

        this.updateMortgageParticipants(this._updatePageState.bind(this));
      }
    } else {
      console.warn('Submission Error, failed to update Wizard state');
    }
  };

  this._getOpenedSection = function (max) {
    var sectionOpened = null;
    var openSteps = this.$formSteps.mogo().getAllActiveSteps();
    if (openSteps.length && (!max || openSteps[0].index < max)) {
      sectionOpened = openSteps[0].$node.find('form');
    }
    return sectionOpened;
  };

  this._setButtonsEnabled = function ($sectionOpened, enabled) {
    $sectionOpened.find('button[type="submit"]').each(function () {
      var $this = $(this);
      if ($this.mogo().declaredClass == 'Button') {
        if (enabled) {
          $this.mogo().removeDisabledLoadState();
        } else {
          $this.mogo().setDisabledLoadState();
        }
      }
    });
  };

  this._updatePageState = function () {
    this._setButtonsEnabled(this._getOpenedSection(), true); // Remove load state from buttons
    this._setMortgageLiabilityAction('applicant');
    this._setMortgageLiabilityAction('coparticipant');
    this._updateSubmissionState();
    this._updateWizardState();
    this._updateStrataToggle();
    this._setupActions();
    this._updateContinueButton();
    this.presenter.updateDOM();
  };

  this._getActionTypeFromAction = function (action) {
    var obj = {};
    var expanded = action.split('.');
    if (expanded[0].indexOf('applicant') > 0) {
      obj.type = 'applicant';
    } else {
      obj.type = 'coparticipant';
    }

    if (expanded[1] === 'update_mortgage_participant') {
      obj.action = 'remove';
    } else if (expanded[1] === 'create_mortgage_existing_mortgage') {
      obj.action = 'create';
    } else if (expanded[1] === 'update_mortgage_existing_mortgage') {
      obj.action = 'update';
    }
    return obj;
  };

  this.destroy = function () {
    this._super();

    // reset models
    this.presenter.resetModels('mortgage_applicant');
    this.presenter.resetModels('mortgage_coparticipant');
    this.presenter.resetModels('mortgage_applicant_mortgage_liability');
    if (this.presenter.models.mortgage_coparticipant_mortgage_liability) this.presenter.resetModels('mortgage_coparticipant_mortgage_liability');
    this.presenter.resetModels('mortgage_applicant_liabilities');
    if (this.presenter.models.mortgage_coparticipant_liabilities) this.presenter.resetModels('mortgage_coparticipant_liabilities');

    for (var i = 0; i < this._actionCallbackArray.length; i++) {
      this.presenter.removeCallbackFromAction(this._actionCallbackArray[i][0], this._actionCallbackArray[i][1]);
    }

    for (var j = 0; j < this._liabilitiesCallbacks.length; j++) {
      this.presenter.removeCallbackFromAction(this._liabilitiesCallbacks[j][0], this._liabilitiesCallbacks[j][1]);
    }

    // remove computed variables
    this.presenter.removeComputedVariable('sameAsApplicant');
    this.presenter.removeComputedVariable('applicant_has_submitted_data');
    this.presenter.removeComputedVariable('coapplicant_has_submitted_data');
    this.presenter.removeComputedVariable('applicant_liabilities_has_submitted_data');
    this.presenter.removeComputedVariable('coapplicant_liabilities_has_submitted_data');
    this.presenter.removeComputedVariable('applicantLiabilitiesIndex');
    this.presenter.removeComputedVariable('applicantLiablitiesTotal');
    this.presenter.removeComputedVariable('coparticipantLiablitiesTotal');
    this.presenter.removeComputedVariable('mortgage_applicant_temp');
    this.presenter.removeComputedVariable('mortgage_coparticipant_temp');
    this.presenter.removeComputedVariable('mortgage_applicant._has_liability_child_temp');
    this.presenter.removeComputedVariable('mortgage_applicant._has_liability_alimony_temp');
    this.presenter.removeComputedVariable('mortgage_coparticipant._has_liability_child_temp');
    this.presenter.removeComputedVariable('mortgage_coparticipant._has_liability_alimony_temp');
  };

  this._toggleAddressFields = function (isUpdate, address_is_the_same_as_applicant) {
    if (address_is_the_same_as_applicant) {
      if (isUpdate) {
        this._copyAddress();
        this._updateAddress(this.presenter.models.account);
      }
      this._enableAddress(false);
    } else {
      if (isUpdate) this._updateAddress(this._tmpAddress);
      this._enableAddress(true);
    }
  };

  this._copyAddress = function () {
    var _this3 = this;

    $.each(this._address, function (key, item) {
      var bind = $(item.node).data('bind');
      _this3._tmpAddress[key] = _this3.presenter.getModelProperty(bind);
    });
  };

  this._updateAddress = function (model) {
    var _this4 = this;

    $.each(this._address, function (key, item) {
      var bind = $(item.node).data('bind');
      _this4.presenter.setModelProperty(bind, model[key]);

      if (key == 'province' && !model[key]) {
        item.setSelectedIndex(0);
      }
    });
  };

  this._enableAddress = function (enabled) {
    $.each(this._address, function (key, item) {
      item.setReadOnly(!enabled);
      if (!enabled) item.hideError();
    });
  };
}